export default __webpack_public_path__ + "static/media/bluemask.05ec17fe.png";